var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_60)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_60",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 0.5H0.5V32.5H26.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.875 30.9V27.7C24.875 26.0026 24.1902 24.3748 22.9712 23.1745C21.7522 21.9743 20.0989 21.3 18.375 21.3H8.625C6.90109 21.3 5.24779 21.9743 4.02881 23.1745C2.80982 24.3748 2.125 26.0026 2.125 27.7V30.9",
    stroke: "#EBB42C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.9C17.0899 14.9 20 12.0346 20 8.50001C20 4.96538 17.0899 2.10001 13.5 2.10001C9.91015 2.10001 7 4.96538 7 8.50001C7 12.0346 9.91015 14.9 13.5 14.9Z",
    stroke: "#EBB42C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f7dd38f3063e455f53ad66798dfd75d3.svg";
export { ForwardRef as ReactComponent };